{
  "version": 1,
  "asset_id": "01e2f564-acd5-4e31-ac58-abaa6a2df77e",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/01e2f564-acd5-4e31-ac58-abaa6a2df77e/svc-technical-seo-1200.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/01e2f564-acd5-4e31-ac58-abaa6a2df77e/svc-technical-seo-1200.webp",
  "original_filename": "svc-technical-seo-1200.webp",
  "size": 24550,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:58Z"
}
